import { PropsWithChildren } from 'react';

import styles from '@components/typography/Typography.module.css';

type Color =
  | 'shadesBlack'
  | 'primary500'
  | 'primary700'
  | 'neutral200'
  | 'neutral700'
  | 'neutral500'
  | 'error500'
  | 'secondary500'
  | 'success500'
  | 'secondary700'
  | 'shadesWhite'
  | 'primary300'
  | 'neutral300'
  | 'achromatic700'
  | 'alertSuccessShade'
  | 'alertWarningBase';

type Props = PropsWithChildren<{
  className?: string;
  color?: Color;
}>;

const BodyCopyBold = ({ children, className, color = 'shadesBlack' }: Props) => (
  <span className={`${styles.bodyCopyBold} ${className ?? ''} ${styles[color]} ${className ?? ''}`}>{children}</span>
);

export default BodyCopyBold;
